import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { FormSpy } from 'react-final-form';

import { getActEventsBlock } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { Button } from 'UIPackage/MainModule/components/Button';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCatalogsInteractionCategorySelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { KnmLateFieldsRemark } from 'KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

import { getKnmDataCreated, getKnmFormRef } from '../../../../../../KnmPackage/MainModule/selectors/knmSelectors';
import { ErknmEventItem } from '../../../../../ErknmEventsModule/components/ErknmEventItem';
import { IKnmErknmFormEvent } from '../../../../../MainModule/interfaces/IKnmErknmFormEvent';
import { IInteractionCategorySelectOption } from '../../../../../../CorePackage/CatalogsModule/interfaces/IInteractionCategorySelectOption';
import { IDictionaryEventTypeSelectOption } from '../../../../../../CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';
import { ErknmFieldMark } from '../../../../../MainModule/components/ErknmFieldMark';
import styles from './ErknmActsItemContentEvents.module.scss';

interface IErknmActsItemProps {
  id: string;
  index: number;
  isDisabledByComplete: boolean;
  isWatchOnly: boolean;
  lateFieldName: string;
  name: string;
  selectedKnmEventTypes: (IDictionaryEventTypeSelectOption | undefined)[] | undefined;
}

interface IErknmActsItemStoreProps {
  allEventInteractionCategoryOptions: IInteractionCategorySelectOption[] | undefined;
  created: string | null | undefined;
  formRef: IKnmFormRef | undefined;
}

const ErknmActsItemContentEventsWithoutStore = ({
  id,
  index,
  isDisabledByComplete,
  isWatchOnly,
  lateFieldName,
  name,
  selectedKnmEventTypes,
  allEventInteractionCategoryOptions,
  created,
  formRef,
}: IErknmActsItemProps & IErknmActsItemStoreProps) => {
  const push = formRef?.current.mutators.push;

  // const selectedKnmEventTypes = formRef?.current
  //   .getFieldState('eventsErknm')
  //   ?.value?.filter(x => x.type && !x.type.inspectionResult)
  //   ?.map(x => x.type);

  const [uniqKnmEventTypesSelectOptions, setUniqKnmEventTypesSelectOptions] = useState<
    IDictionaryEventTypeSelectOption[] | undefined
    // @ts-ignore
  >(selectedKnmEventTypes);

  // @ts-ignore
  const eventsBlockId = getActEventsBlock(id);

  const isDisabledField = isWatchOnly || isDisabledByComplete;

  const addEvent = useCallback(() => {
    if (!isWatchOnly && push) {
      const addingEvent: IKnmErknmFormEvent = {
        guid: undefined,
        type: undefined,
        startDate: undefined,
        stopDate: undefined,
        dateCreate: undefined,
        inspectors: undefined,
        submittedDocuments: undefined,
        listId: uuidv4(),
        isNew: true,
      };

      push(`${name}.events`, addingEvent);
    }
  }, [formRef, push, isWatchOnly]);

  useEffect(() => {
    if (selectedKnmEventTypes?.length && uniqKnmEventTypesSelectOptions?.length !== selectedKnmEventTypes?.length) {
      // @ts-ignore
      setUniqKnmEventTypesSelectOptions(selectedKnmEventTypes);
    }
  }, [uniqKnmEventTypesSelectOptions?.length, selectedKnmEventTypes?.length]);

  return (
    <>
      <FieldBlock
        id={eventsBlockId}
        margin="top"
        label={
          <>
            Перечень осуществленных действий
            <ErknmFieldMark fieldName={`${name}.events`} />
          </>
        }
        tooltip={<KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/events`} fieldId={eventsBlockId} />}
        button={
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            disabled={isDisabledField}
            onClick={addEvent}
          />
        }
      >
        <ErknmEventItem
          interactionCategoryOptions={allEventInteractionCategoryOptions}
          name={`${name}.events`}
          watchOnly={isDisabledField}
          uniqKnmEventTypesSelectOptions={uniqKnmEventTypesSelectOptions}
          setUniqKnmEventTypesSelectOptions={setUniqKnmEventTypesSelectOptions}
          formRef={formRef}
          // @ts-ignore
          knmEventTypesSelectOptions={selectedKnmEventTypes}
          created={created}
          actId={id}
          isActEvent={true}
          lateFieldName={`${lateFieldName}/events`}
        />
      </FieldBlock>
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          if (props.errors?.acts && props.errors?.acts[index]?.events) {
            const fieldError = props.errors.acts[index].events;
            const isFieldTouched = props.touched?.acts;

            if (isFieldTouched && typeof fieldError === 'string') {
              return (
                <p className={`${styles.knoActEventsFormSpyMessage} shared-input-error`}>Поле не может быть пустым</p>
              );
            }
          }

          return null;
        }}
      </FormSpy>
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmActsItemStoreProps => ({
  allEventInteractionCategoryOptions: getCatalogsInteractionCategorySelectOptions(state),
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
});

export const ErknmActsItemContentEvents = connect(mapStateToProps)(ErknmActsItemContentEventsWithoutStore);
